module.exports = __webpack_public_path__ + "img/head_circles_decor.867ae2d.svg";